//SET ERROR STATE


export const setErrorState = (payload) => ({
    type : 'SET_ERROR_STATE',
    payload
});




// WEBPACK FOOTER //
// ./src/Actions/errorHandler.js